import { render } from "./indexfourdoctors.vue?vue&type=template&id=22460a59"
import script from "./indexfourdoctors.vue?vue&type=script&lang=js"
export * from "./indexfourdoctors.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__